<template>
  <div class="b_box">
    <div class="container">
      <div class="top_title">
        <div class="t_data">
          <div class="s_data" v-if="selectKey=='today'">
            <div class="s_left" @click="preDate">
              <img src="../../../../assets/image/arrow_left.png" />
              <span>上一天</span>
            </div>
            <span class="center" :class="{'center_active':clickNum==0}">{{aboutDay|filtDate}}</span>
            <div class="s_left s_right" :class="{'nextactive':true}" @click="nextDate">
              <span :class="{'s_active':clickNum==0}">下一天</span>
              <img src="../../../../assets/image/arrow_right.png" :class="{'s_active':clickNum==0}"/>
            </div>
          </div>
          <div class="s_data" v-if="selectKey=='week'">
            <div class="s_left" @click="preWeek">
              <img src="../../../../assets/image/arrow_left.png" />
              <span>上周</span>
            </div>
            <span
              class="center"
              :class="{'center_active':clickNum==0}"
            >{{startWeekTime}} 至 {{endWeekTime}}</span>
            <div class="s_left s_right" @click="nextWeek">
              <span :class="{'s_active':clickNum==0}">下周</span>
              <img src="../../../../assets/image/arrow_right.png" :class="{'s_active':clickNum==0}"/>
            </div>
          </div>
          <div class="s_data" v-if="selectKey=='month'">
            <div class="s_left" @click="preMouth">
              <img src="../../../../assets/image/arrow_left.png" />
              <span>上月</span>
            </div>
            <span
              class="center"
              :class="{'center_active':clickNum==0}"
            >{{currentMouth.substring(0,4)}}年{{currentMouth.substring(5,7)}}月份</span>
            <div class="s_left s_right" @click="nextMouth">
              <span :class="{'s_active':clickNum==0}">下月</span>
              <img src="../../../../assets/image/arrow_right.png" :class="{'s_active':clickNum==0}"/>
            </div>
          </div>
          <div class="s_data two_data" v-if="selectKey=='all'">
            <div class="all_left" @click="AllstartTime">
              <span :class="{'all_active':isopacity}">{{startAllTime}}</span>
              <img src="../../../../assets/image/icon_la.png" />
            </div>
            <span class="all_center" :class="{'all_active':isopacity}">至</span>
            <div class="all_left" @click="AllendTime">
              <span :class="{'all_active':isopacity}">{{endAllTime}}</span>
              <img src="../../../../assets/image/icon_la.png" />
            </div>
        </div>
        </div>
      </div>
    </div>
    <div class="content_list">
            <van-list
                ref="vanList"
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                :immediate-check="false"
                @load="onLoad"
                class="wrapper"
            >
                <div
                class="reject"
                v-for="(item,index) in proList"
                :key="index"
                @click="goDetail(item)"
                >
                <div class="reject_item">
                    <div class="reject_top">
                      <div class="title">
                        <p class="title_text">{{item.defendantName}}</p>
                        <p class="title_tag" :class="{'ss1': item.urgency === '一般'}" v-if="item.urgency === '一般'"> {{ item.urgency }}</p>
                        <p class="title_tag" :class="{'ss2': item.urgency === '较重'}" v-if="item.urgency === '较重'"> {{ item.urgency }}</p>
                        <p class="title_tag" :class="{'ss3': item.urgency === '严重'}" v-if="item.urgency === '严重'"> {{ item.urgency }}</p>
                        <!-- <p
                        class="title_tag"
                        :class="sstt[item.urgencyDegree == '' ? '': Number(item.urgencyDegree-7)]"
                        >{{sttText[item.urgencyDegree == '' ? '': Number(item.urgencyDegree-7)]}}</p> -->
                      </div>
                      <div class="info1">
                          <span><img src="../../../../assets/complaint/adress.png" alt=""></span><span>{{item.belongMechanismName}}</span>
                      </div>
                      <div class="info">
                          <span>投诉人姓名:</span>
                          <span>{{item.complainName}}</span>
                      </div>
                      <div class="info">
                          <span>投诉时间:</span>
                          <span>{{item.complainTime}}</span>
                      </div>
                      <div class="info">
                          <span>投诉单号:</span>
                          <span>{{item.mainComplainNumber}}</span>
                      </div>
                      <div class="info_line">
                          <p>处置状态:</p>
                          <p class="info_time">{{item.handleTime|filt3()}}</p>
                          <p></p>
                          <p>{{item.handleTimeLimit|filt4()}}</p>
                      </div>
                    </div>
                    <div class="line line_bottom"></div>
                    <div class="status">
                      <p>{{item.statueName}}</p>
                      <p>
                          <span>查看详情</span>
                          <span>
                              <img src="../../../../assets/image/right.png" alt="">
                          </span>
                      </p>
                    </div>
                </div>
                <!-- <div class="space"></div> -->
                </div>
            </van-list>
    </div>
    <div class="box1" v-if="isNolist">
        <img src="../../../../assets/empty/ic_wuxingxi.png" />
        <p class="tip1">暂无信息</p>
    </div>
    <timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
  </div>
</template>
<script>
    import moment from 'moment';
    import timePick from '../../../../components/base/timePick';
    import API from './../../../../service/modules/complaintApis';
    import util from '../../../../utils/common';
    export default {
        components: {
            timePick
        },
        data () {
            return {
                isNolist: false,
                baseList: '',
                currentTime: new Date().getTime(),
                // currentMouth: moment(new Date().getTime()).format('YYYY-MM'),
                // currentMouth: moment(new Date(moment(decodeURI(this.$route.query.startTime)).format('YYYY-MM-DD')).getTime()).format('YYYY-MM'),
                currentMouth:  moment(new Date(this.$route.query.startTime)).format('YYYY-MM-DD'),
                selectKey: 'all',
                cityCode: this.$router.currentRoute.query.citycode,
                refundType: this.$router.currentRoute.query.refundType,
                // aboutDay: moment(new Date().getTime()).format('YYYY-MM-DD'),
                // aboutDay: moment(decodeURI(this.$route.query.startTime)).format('YYYY-MM-DD'),
                aboutDay: moment(new Date(this.$route.query.startTime)).format('YYYY-MM-DD'),
                // startWeekTime: moment(new Date(decodeURI(moment(decodeURI(this.$route.query.startTime)).format('YYYY-MM-DD'))).getTime()).format('YYYY-MM-DD'),
                startWeekTime: moment(new Date(this.$route.query.startTime)).format('YYYY-MM-DD'),
                // endWeekTime: moment(new Date(decodeURI(moment(decodeURI(this.$route.query.endTime)).format('YYYY-MM-DD'))).getTime()).format('YYYY-MM-DD'),
                // endWeekTime: util.getStampInDateDay(this.$route.query.endTime),
                endWeekTime: moment(new Date(this.$route.query.endTime)).format('YYYY-MM-DD'),
                // startAllTime: moment(decodeURI(this.$route.query.startTime)).format('YYYY-MM-DD'),
                startAllTime:moment(new Date(this.$route.query.startTime)).format('YYYY-MM-DD'),
                // endAllTime: moment(decodeURI(this.$route.query.endTime)).format('YYYY-MM-DD'),
                endAllTime: moment(new Date(this.$route.query.endTime)).format('YYYY-MM-DD'),
                changeTime: '',
                // startTime: moment(decodeURI(this.$route.query.startTime)).format('YYYY-MM-DD') + ' 00:00:00',
                startTime:moment(new Date(this.$route.query.startTime)).format('YYYY-MM-DD') + ' 00:00:00',
                // endTime: moment(decodeURI(this.$route.query.endTime)).format('YYYY-MM-DD') + ' 23:59:59',
                endTime: moment(new Date(this.$route.query.endTime)).format('YYYY-MM-DD') + ' 23:59:59',
                proList: [],
                total: '0',
                totalPrice: '0',
                cityName: this.$router.currentRoute.query.cityName,
                clickNum: this.$route.query.clickNum,
                isopacity: true,
                totalCityPrice: 0,
                currentTotalPrice: 0,
                showchangeStatus: false,
                finished: false,
                finishedText: '没有更多',
                loading: true,
                isShow: false,
                typeLevel: 1,
                cityValue: '',
                areaId: this.$route.query.areaOne,
                pointType: this.$route.query.type,
                type: 'notCompletePoint',
                totalSize: '',
                sstt: [
                    'ss1',
                    'ss2',
                    'ss3'
                ],
                sttText: [
                    '一般',
                    '较重',
                    '严重'
                ],
                pageIndex: '0',
                paramObj: {}
            };
        },
        created () {
            console.error(this.startWeekTime);
            console.log(this.$route.query);
            this.paramObj = this.$route.query;
            this.getInfoList();
        },
        methods: {
            goDetail (value) {
                this.$router.push({
                    name: 'workListDetails',
                    params: {
                        item: value
                    }
                });
                util.setJsonLocal('item', value);
                this.$store.commit('complaint/getItemList', value);
            },
            showNext () {
                if (this.aboutDay === moment(new Date().getTime()).format('YYYY-MM-DD')) {
                    return true;
                } else {
                    return false;
                }
            },
            getInfoList () {
                this.proList.splice(0, this.proList.length);
                this.pageIndex = 1
                API.common.getComplainStateDetailList({
                    pageSize: 4,
                    curPage: this.pageIndex,
                    stateType: this.paramObj.dafaultType,
                    startDate: this.startTime,
                    endDate: this.endTime,
                    place: this.areaId
                }).then(res => {
                    if (res.ret) return false;
                    this.loading = false; // 加载参数
                    if (res.data.list.length > 0) { // 有数据
                        this.proList.push(...res.data.list);
                        if (this.proList.length === res.data.totalSize) { // 已加载完了
                            this.finished = true;
                        } else {
                            this.finished = false;
                        }
                        this.isNolist = false;
                        this.finishedText = '没有更多';
                    } else {
                        this.finished = true;
                        this.loading = false;
                        this.isNolist = true;
                        this.finishedText = '';
                    }
                });
            },
            getMore () {
                API.common.getComplainStateDetailList({
                    pageSize: 4,
                    curPage: this.pageIndex,
                    stateType: this.paramObj.dafaultType,
                    startDate: this.startTime,
                    endDate: this.endTime,
                    place: this.areaId
                }).then(res => {
                    if (res.ret) return false;
                    this.loading = false; // 加载参数
                    if (res.data.list.length > 0) { // 有数据
                        this.proList.push(...res.data.list);
                        if (this.proList.length === res.data.totalSize) { // 已加载完了
                            this.finished = true;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                        this.finishedText = '没有更多';
                    } else {
                        this.finished = true;
                        this.isNolist = true;
                        this.finishedText = '';
                    }
                });
            },
            AllstartTime () {
                this.changeTime = 'startTime';
                this.$refs.timePick.showPicker();
            },
            AllendTime () {
                this.changeTime = 'endTime';
                this.$refs.timePick.showPicker();
            },
            getTimeValue (value) {
                console.log(2000, value);
                if (this.changeTime === 'startTime') {
                    if (new Date(value).getTime() < new Date('2018-01-01').getTime()) {
                        // 选择时间小于最小的时间
                        this.$Toast({
                            message: '起始时间不能小于2018-01-01'
                        });
                        return;
                    } else if (
                        new Date(value).getTime() > new Date(this.endTime).getTime()
                    ) {
                        this.$Toast({
                            message: '起始时间不能大于开始时间'
                        });
                        return;
                    }
                    this.isopacity = false;
                    this.startAllTime = value;
                    this.startTime = value + ' ' + '00:00:00';
                } else {
                    if (new Date(value).getTime() < new Date(this.startAllTime).getTime()) {
                        this.$Toast({
                            message: '结束时间不能小于开始时间'
                        });
                        return;
                    }
                    this.isopacity = false;
                    this.endAllTime = value;
                    this.endTime = value + ' ' + '23:59:59';
                }
                this.getInfoList();
            },
            preDate () {
                // 上一天

                this.clickNum++;
                const currentDate = new Date(this.aboutDay).getTime();
                this.aboutDay = moment(currentDate - 24 * 60 * 60 * 1000).format(
                    'YYYY-MM-DD'
                );
                console.log(this.aboutDay);
                this.startTime = this.aboutDay + ' ' + '00:00:00';
                this.endTime = this.aboutDay + ' ' + '23:59:59';
                this.getInfoList();
            },
            nextDate () {
                // 下一天
                if (this.clickNum === 0) {
                    return;
                } else {
                    this.clickNum--;
                }
                const currentDate = new Date(this.aboutDay).getTime();
                this.aboutDay = moment(currentDate + 24 * 60 * 60 * 1000).format(
                    'YYYY-MM-DD'
                );
                this.currentTime = moment(new Date(this.aboutDay).getTime()).format('YYYY-MM-DD');
                this.startTime = this.aboutDay + ' ' + '00:00:00';
                this.endTime = this.aboutDay + ' ' + '23:59:59';
                this.getInfoList();
            },
            preMouth () {
                // 上一个月
                this.clickNum++;
                if (new Date(this.currentMouth).getMonth() > 0) {
                    var month = parseInt(new Date(this.currentMouth).getMonth());
                    if (month < 10) {
                        month = '0' + month;
                    }
                    this.currentMouth =
                        new Date(this.currentMouth).getFullYear() + '-' + month + '';
                } else {
                    this.currentMouth =
                        parseInt(new Date(this.currentMouth).getFullYear()) - 1 + '-' + '12';
                }
                var time = new Date(
                    this.currentMouth.substring(0, 4),
                    this.currentMouth.substring(5, 7),
                    0
                );
                this.startTime = this.currentMouth + '-01' + ' ' + '00:00:00';
                this.endTime = this.currentMouth + '-' + time.getDate() + ' ' + '23:59:59';
                this.getInfoList();
            },
            nextMouth () {
                // 下一个月
                if (this.clickNum === 0) {
                    return;
                } else {
                    this.clickNum--;
                }
                var month = parseInt(new Date(this.currentMouth).getMonth()) + 2;
                if (month < 10) {
                    month = '0' + month;
                }
                if (month > 12) {
                    this.currentMouth =
                        parseInt(new Date(this.currentMouth).getFullYear()) + 1 + '-' + '01';
                } else {
                    this.currentMouth = new Date(this.currentMouth).getFullYear() + '-' + month;
                }
                var time = new Date(
                    this.currentMouth.substring(0, 4),
                    this.currentMouth.substring(5, 7),
                    0
                );
                this.startTime = this.currentMouth + '-01' + ' ' + '00:00:00';
                this.endTime = this.currentMouth + '-' + time.getDate() + ' ' + '23:59:59';
                this.getInfoList();
            },
            preWeek () {
                // 上一周
                this.clickNum++;
                this.endWeekTime = moment(
                    new Date(this.startWeekTime).getTime() - 24 * 36e5
                ).format('YYYY-MM-DD');
                this.startWeekTime = moment(
                    new Date(this.startWeekTime).getTime() - 7 * 24 * 36e5
                ).format('YYYY-MM-DD');
                this.startTime = this.startWeekTime + ' ' + '00:00:00';
                this.endTime = this.endWeekTime + ' ' + '23:59:59';
                this.getInfoList();
            },
            nextWeek () {
                // 下一周
                if (this.clickNum === 0) {
                    return;
                } else {
                    this.clickNum--;
                }
                this.startWeekTime = moment(
                    new Date(this.endWeekTime).getTime() + 24 * 36e5
                ).format('YYYY-MM-DD');
                this.endWeekTime = moment(
                    new Date(this.endWeekTime).getTime() + 7 * 24 * 36e5
                ).format('YYYY-MM-DD');
                this.startTime = this.startWeekTime + ' ' + '00:00:00';
                this.endTime = this.endWeekTime + ' ' + '23:59:59';
                this.getInfoList();
            },
            changeStatus (value) {
                // 选择退货状态
                if (value === 'refundSuccess') {
                    this.showchangeStatus = true;
                } else {
                    this.showchangeStatus = false;
                }
                this.refundType = value;
            },
            onLoad () {
                this.pageIndex++;
                this.getMore();
            }
        },
        filters: {
            filt (value) {
                if (parseInt(value) < 10000) {
                    return value;
                } else if (parseInt(value) >= 10000 && parseInt(value) < 100000000) {
                    return (parseInt(value) / 10000).toFixed(2);
                } else if (parseInt(value) >= 100000000) {
                    return (parseInt(value) / 100000000).toFixed(2);
                }
            },
            // 时长计算
            filt3 (str) {
                let duration = str;

                let zero = function (times) {
                    return times;
                }
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.ceil((duration / 60 % 60)));
                let times = ''
                if (hour > 0) {
                    times += hour + '小时'
                }
                times += minutes + '分钟'
                return times
            },
            // 计算时限
            filt4 (str) {
                let duration = str;
                let zero = function (times) {
                    return times;
                }
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.ceil((duration / 60 % 60)));
                let times = ''
                if (hour > 0) {
                    times += hour + 'h';
                }
                if (minutes > 0) {
                    times += minutes + 'm';
                }
                return times
            },
            filt5 (value) {
                return value.substring(0, 10);
            },
            filt6 (value) {
                return value.substring(0, 10);
            },
            filtDate (value) {
                return value.substring(0, 10);
            }
        }
    };
</script>
<style scoped lang="less">
.b_box {
  background-color: #fafafa;
  width: 100%;
  height: 100%;
  .content_list {
        width: 100%;
        .wrapper {
            padding-top: 68px;
        }
        .s_city {
            width: 100%;
            text-align: center;
            border-bottom: 1px solid #efefef;
            margin-top: 20px;
            img {
                display: inline-block;
                width: 48px;
                height: 14px;
            }
        }
        /ddep/.van-list__finished-text {
          background: #fafafa;
        }
        .reject {
        width: 100%;
        background-color: #fafafa;
        padding-bottom: 16px;
        .reject_item {
            margin-left: 12px;
            margin-right: 12px;
            box-sizing: border-box;
            background-color: #ffffff;
            box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
            border-radius: 3px;
            .reject_top {
              width:100%;
              padding: 16px;
              .title {
                width:100%;
                display: flex;
                justify-content: space-between;
                .title_text {
                    font-size: 14px;
                    line-height:18px;
                    // color:red;
                    font-weight: 700;
                    color: #2a2a2a;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding-top:2px;
                }
                .title_tag {
                    width: 36px;
                    height: 18px;
                    font-size: 10px;
                    color: #FFFFFF;
                    border-radius: 9px;
                    text-align: center;
                    line-height: 20px;
                }
                .ss1{
                    background: #118BF5;
                }
                .ss2{
                    background: #FFA509;
                }
                .ss3{
                    background: #F75C32;
                }
              }
              .info {
                  margin-top: 16px;
                  span:nth-child(1) {
                      display: inline-block;
                      width: 84px;
                      font-size: 14px;
                      color: #777;
                  }
                  span:nth-child(2) {
                      display: inline-block;
                      font-size: 14px;
                  }
                  span {
                      font-size: 14px;
                      color: #777;

                  }
                  .info_time {
                      color: #36B374;
                  }
              }
              .info1 {
                  margin-top: 12px;
                  display: flex;
                  img {
                      width: 14px;
                      margin-top:2px;
                  }
                  span:nth-child(2) {
                      font-size:14px;
                      font-weight:400;
                      color:rgba(143,143,143,1);
                      line-height:22px;
                      margin-left:4px;
                  }
              }
              .info_line {
                  margin-top: 16px;
                  display: flex;
                  height: 14px;
                  p:nth-child(1) {
                      display: inline-block;
                      width: 84px;
                      font-size: 14px;
                      color: #777;
                  }
                  p:nth-child(2) {
                      display: inline-block;
                      font-size: 14px;
                  }
                  p:nth-child(3) {
                    content: '';
                    margin: 2px 5px;
                    background: #999999;
                    width: 1px;
                    height: 18px;
                    -webkit-transform: scaleY(0.5);
                    transform: scale(0.5);
                    -webkit-transform-origin: 0 0;
                    transform-origin: 0 0;
                  }
                  p {
                      font-size: 14px;
                      color: #777;
                      height: 100%;

                  }
                  .info_time {
                      color: #36B374;
                  }
              }
            }
            .line {
                width: 100%;
                height: 1px;
            }
            .status {
                width: 100%;
                padding: 15px 16px;
                font-size: 14px;
                color: #333333;
                font-weight: 400;
                display: flex;
                justify-content: space-between;
                p:nth-child(2) {
                    display: flex;
                    align-items: center;
                    span {
                        color: #999999;
                        font-size: 12px;
                    }
                }
                p>span>img {
                    width: 4px;
                    height: 7px;
                    margin-left: 4px;
                    margin-top:-3px;
                }
            }
        }
            .space {
                width: 100%;
                height: 24px;
                background-color: #fafafa;
            }
        }
    }
    .box1 {
        text-align: center;
        margin-top: 216px;
        img {
            display: inline-block;
            width: 72px;
            height: 64px;
        }
        .tip1 {
            font-size: 14px;
            color: #9b9b9b;
            margin-top: 24px;
        }
        .tip2 {
            font-size: 14px;
            color: #9b9b9b;
            margin-top: 8px;
        }
    }
}
.container {
  .top_title {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    background-color: #36b374;
    .s_time {
      height: 30px;
      padding: 20px 16px 0 16px;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-around;
      font-size: 16px;
      color: #666;
      background-color: #36b374;
      border: 1px solid #ffffff;
      border-radius: 2px;
      .item {
        display: block;
        float: left;
        width: 25%;
        height: 100%;
        line-height: 30px;
        text-align: center;
        color: #ccc;
        border-right: 1px solid #ffffff;
      }
      .item:last-child {
        border: none;
      }
      .select_active {
        color: #36b374;
        background-color: #fff;
      }
    }
    .t_data {
      width: 100%;
      height: 50px;
      background: #36b374;
      padding: 20px 16px 0 16px;
      box-sizing: border-box;
      position: relative;
      .jiao {
        position: absolute;
        left: 29px;
        top: -21px;
        width: 14px;
        height: 14px;
        border-top: 14px solid transparent;
        border-right: 14px solid transparent;
        border-bottom: 14px solid #36b374;
        border-left: 14px solid transparent;
      }
      .jiao1_active {
        left: 29px;
      }
      .jiao2_active {
        left: 120px;
      }
      .jiao3_active {
        left: 210px;
      }
      .jiao4_active {
        left: 307px;
      }
      .s_data {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        .s_left {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          flex-direction: row;
          img {
            width: 7px;
            height: 11px;
          }
          span {
            font-size: 14px;
            color: #fff;
            margin-left: 6px;
          }
          .s_active {
            opacity: 0.3 !important;
          }
        }
        .all_center {
          font-size: 14px;
          color: #fff;
          opacity: 0.4;
        }
        .all_left {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          flex-direction: row;
          span {
            font-size: 14px;
            color: #fff;
          }
          img {
            width: 11px;
            height: 7px;
            margin-left: 6px;
          }
          .s_active {
            opacity: 0.3 !important;
          }
        }
        // .all_active {
        //   opacity: 0.5;
        // }
        .s_right {
          img {
            margin-left: 6px;
          }
        }
        .nextactive {
          color: #ccc;
        }
        .center {
          color: #fff;
          font-size: 14px;
        }
        .center_active {
          opacity: 0.5 !important;
        }
      }
      .two_data {
        justify-content: space-around;
      }
    }
  }
  .box_nav {
    width: 100%;
    text-align: center;
    font-size: 0;
    padding-top: 20px;
    .box_item:nth-child(1) {
      border-left: 1px solid rgba(255, 255, 255, 0.5);
    }
    .box_item {
      display: inline-block;
      width: 78px;
      height: 30px;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      text-align: center;
      line-height: 30px;
      font-size: 14px;
      color: #fff;
      opacity: 0.7;
    }
    .select_active1 {
      background-color: #fff;
      color: #4b77b0;
      opacity: 1;
    }
  }
  .all_list {
    box-sizing: border-box;
    margin-left: 16px;
    margin-right: 16px;
    overflow: hidden;
    margin-top: 250px;
    background-color: #fafafa;
    .all_list_top {
      margin-top: 65px;
      overflow: hidden;
      background-color: #ffffff;
      padding-left: 18px;
      padding-right: 18px;
      margin-bottom: 20px;
      box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
    }
    .all_list_item {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      line-height: 32px;
      span {
        font-size: 14px;
        color: #4a4a4a;
      }
    }
    .all_list_active {
      border-bottom: 1px solid #efefef;
    }
    .all_item {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid #efefef;
      padding: 24px 0;
      font-size: 0;
      .tip_one {
        font-size: 13px;
        width: 40%;
        line-height: 16px;
        color: #4a4a4a;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tip_two {
        width: 20%;
        font-size: 14px;
        color: #4a4a4a;
        text-align: left;
      }
      .right {
        width: 40%;
        // display: flex;
        // display: -webkit-flex;
        // align-items: center;
        // flex-direction: row;
        text-align: right;
        .price {
          font-size: 14px;
          color: #4a4a4a;
          display: inline-block;
          margin-right: 10px;
          // color:red;
        }
        .arrow_right {
          width: 5px;
          height: 8px;
          margin-left: 6px;
          display: inline-block;
        }
      }
    }
    .box1 {
      text-align: center;
      margin-top: 64px;
      height: 268px;
      img {
        display: inline-block;
        width: 155px;
        height: 155px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 28px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
    .all_list_null{
      background-color: #fafafa;
      width: 100%;
      height: 330px;
    }
  }
  .animate_active {
    animation: changehide 1s ease-out forwards;
  }
  .animate_active1 {
    animation: changehide1 1s ease-out backwards;
  }
  @keyframes changehide {
    0% {
      opacity: 1;
      right: 0;
    }
    100% {
      opacity: 0.4;
      right: -35px;
    }
  }
  .go_home {
    position: fixed;
    right: 0;
    top: 538px;
    width: 59px;
    height: 59px;
    background-color: #e4f5ff;
    padding: 9px 10px 9px 9px;
    border-radius: 29px 0 0 29px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
